import React, { useEffect, useState } from 'react';
import { 
  User, 
  Mail, 
  MapPin, 
  Heart, 
  Star, 
  ShieldCheck, 
  CreditCard,
  ChevronRight,
  Zap
} from 'lucide-react';
import axios from 'axios';
import { Layout } from '@/components/Layout';

const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchUsers = async () => {
    try {
      const res = await axios.get("https://api.imtahanplus.com/api/auth/getUserler");

      setUsers(res.data.users);
    } catch (err) {
      console.error(err);
      setError("User-lər yüklənmədi");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  if (loading) return <p>Yüklənir...</p>;
  if (error) return <p>{error}</p>;





  return (
    <Layout breadcrumbs={[{ label: "İstifadəçilər", path: "/users" }]}>
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto">
        <header className="mb-8">
          <h1 className="text-2xl font-bold text-gray-900">İstifadəçi İdarəetmə Paneli</h1>
          <p className="text-gray-500 text-sm">Ümumi {users?.length} qeydiyyatlı istifadəçi tapıldı.</p>
        </header>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="bg-gray-50 border-b border-gray-200">
                  <th className="px-6 py-4 text-xs font-semibold text-gray-600 uppercase tracking-wider">İstifadəçi</th>
                  <th className="px-6 py-4 text-xs font-semibold text-gray-600 uppercase tracking-wider">Region / Qrup</th>
                  <th className="px-6 py-4 text-xs font-semibold text-gray-600 uppercase tracking-wider">Statistika</th>
                  <th className="px-6 py-4 text-xs font-semibold text-gray-600 uppercase tracking-wider">Status</th>
                  <th className="px-6 py-4 text-xs font-semibold text-gray-600 uppercase tracking-wider">Ödənişlər</th>
                  <th className="px-6 py-4 text-xs font-semibold text-gray-600 uppercase tracking-wider text-right">Əməliyyat</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {users?.map((user) => (
                  <tr key={user._id} className="hover:bg-gray-50 transition-colors">
                    {/* İstifadəçi Temel Bilgileri */}
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 font-bold uppercase">
                          {user.name?.charAt(0)}
                        </div>
                        <div>
                          <div className="text-sm font-medium text-gray-900">{user.name}</div>
                          <div className="text-xs text-gray-500 flex items-center gap-1">
                            <Mail size={12} /> {user.email}
                          </div>
                        </div>
                      </div>
                    </td>

                    {/* Region ve Qrup */}
                    <td className="px-6 py-4 text-sm text-gray-600">
                      <div className="flex flex-col gap-1">
                        <span className="flex items-center gap-1 italic"><MapPin size={14} /> {user.region}</span>
                        <span className="text-[11px] font-semibold bg-blue-50 text-blue-700 px-2 py-0.5 rounded-full w-fit">
                          {user.abituriyent_group}. Qrup
                        </span>
                      </div>
                    </td>

                    {/* Statistika (XP ve Hearts) */}
                    <td className="px-6 py-4 text-sm">
                      <div className="flex items-center gap-4">
                        <div className="flex items-center gap-1 text-amber-600 font-medium" title="XP">
                          <Star size={16} fill="currentColor" /> {user.xp}
                        </div>
                        <div className="flex items-center gap-1 text-red-500 font-medium" title="Hearts">
                          <Zap size={16} fill="currentColor" /> {user.hearts}
                        </div>
                      </div>
                    </td>

                    {/* Premium Status */}
                    <td className="px-6 py-4 text-sm text-gray-600">
                      {user.is_premium ? (
                        <span className="inline-flex items-center gap-1 text-green-600 font-medium bg-green-50 px-2 py-1 rounded-md">
                          <ShieldCheck size={16} /> Premium
                        </span>
                      ) : (
                        <span className="text-gray-400">Standart</span>
                      )}
                    </td>

                    {/* Ödeme Özeti */}
                    <td className="px-6 py-4 text-sm text-gray-600">
                      <div className="flex flex-col text-[11px]">
                        <span className="flex items-center gap-1">
                          <CreditCard size={12} /> Tarixçə: {user.paymentHistory?.length || 0}
                        </span>
                        <span className="text-indigo-600">
                          İmtahanlar: {user.examPayments?.length || 0}
                        </span>
                      </div>
                    </td>

                    {/* Aksiyon */}
                    <td className="px-6 py-4 text-right">
                      <button className="p-2 hover:bg-gray-200 rounded-lg text-gray-400 hover:text-gray-600 transition-all">
                        <ChevronRight size={20} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    </Layout>
  );
};

export default UserManagement;